<template>
  <div class="ui-container">
    <h2>Form</h2>
    <h3>Input</h3>
    <div class="ui-block inline">
      <InputWrapper
        label="Label"
        helper="Helper text goes here"
        name="noPlaceholder"
        v-model="emptyValue"
      />
      <InputWrapper
        label="Label"
        helper="Helper text goes here"
        name="placeholder"
        placeholder="Placeholder"
        v-model="emptyValue"
      />
      <InputWrapper
        label="Label"
        helper="Helper text goes here"
        name="value"
        v-model="inputValue"
      />
      <InputWrapper
        label="Label"
        class="invalid"
        helper="Helper text goes here"
        name="invalid"
        :invalid="true"
        v-model="inputValue"
      />
      <InputWrapper
        label="Label"
        class="valid"
        helper="Helper text goes here"
        name="valid"
        v-model="inputValue"
      />
      <InputWrapper
        label="Label"
        class="disabled"
        helper="Helper text goes here"
        name="disabled"
        :disabled="true"
        v-model="inputValue"
      />
    </div>
    <div class="ui-block inline">
      <InputWrapper label="Label" name="noPlaceholder" v-model="emptyValue" />
      <InputWrapper
        label="Label"
        name="placeholder"
        placeholder="Placeholder"
        v-model="emptyValue"
      />
      <InputWrapper label="Label" name="value" v-model="inputValue" />
      <InputWrapper
        label="Label"
        class="invalid"
        helper="Helper text goes here"
        name="invalid"
        :invalid="true"
        v-model="inputValue"
      />
      <InputWrapper
        label="Label"
        class="valid"
        name="valid"
        v-model="inputValue"
      />
      <InputWrapper
        label="Label"
        class="disabled"
        name="disabled"
        :disabled="true"
        v-model="inputValue"
      />
    </div>
    <h3>Textarea</h3>
    <div class="ui-block inline">
      <InputWrapper
        label="Label"
        input="textarea"
        helper="Helper text goes here"
        name="noPlaceholder"
        v-model="emptyValue"
      />
      <InputWrapper
        label="Label"
        input="textarea"
        helper="Helper text goes here"
        placeholder="placeholder"
        name="placeholder"
        v-model="emptyValue"
      />
      <InputWrapper
        label="Label"
        input="textarea"
        helper="Helper text goes here"
        placeholder="placeholder"
        name="value"
        v-model="inputValue"
      />
    </div>
    <h3>Select</h3>
    <div class="ui-block inline">
      <InputWrapper label="Label" input="other" name="select">
        <v-select
          id="select"
          name="select"
          v-model="emptyValue"
          :options="['France', 'UK', 'USA']"
        />
      </InputWrapper>
      <InputWrapper label="Label" input="other" name="select">
        <v-select
          id="select"
          name="select"
          placeholder="Select a country"
          v-model="emptyValue"
          :options="['France', 'UK', 'USA']"
        />
      </InputWrapper>
      <InputWrapper label="Label" input="other" name="select">
        <v-select
          id="select"
          name="select"
          placeholder="Select a country"
          v-model="selectValue"
          :options="['France', 'UK', 'USA']"
        />
      </InputWrapper>
      <InputWrapper label="Label" input="other" name="select">
        <v-select
          id="select"
          name="select"
          placeholder="Select a country"
          v-model="selectMultipleValue"
          :multiple="true"
          :options="['France', 'UK', 'USA']"
        />
      </InputWrapper>
      <InputWrapper label="Label" input="other" name="select">
        <v-select
          id="select"
          name="select"
          placeholder="Select a country"
          v-model="emptyValue"
          :invalid="true"
          helper="Helper text goes here"
          :options="['France', 'UK', 'USA']"
        />
      </InputWrapper>
      <InputWrapper label="Label" input="other" name="select">
        <v-select
          id="select"
          name="select"
          placeholder="Select a country"
          v-model="emptyValue"
          :invalid="true"
          :disabled="true"
          helper="Helper text goes here"
          :options="['France', 'UK', 'USA']"
        />
      </InputWrapper>
    </div>
    <h3>Checkbox</h3>
    <div class="ui-block">
      <div class="checkbox-group">
        <input type="checkbox" id="checkbox" name="checkbox" />
        <label for="checkbox">Checkbox</label>
      </div>
      <div class="checkbox-group">
        <input type="checkbox" id="checkbox2" name="checkbox2" checked />
        <label for="checkbox2">Checkbox 2</label>
      </div>
      <div class="checkbox-group">
        <input type="checkbox" id="checkbox3" name="checkbox3" disabled />
        <label for="checkbox3">Checkbox 3</label>
      </div>
    </div>
    <h3>Checkbox - toggle</h3>
    <div class="ui-block">
      <div class="checkbox-group">
        <div class="toggle">
          <input type="checkbox" />
          <label></label>
        </div>
        <div class="toggle">
          <input type="checkbox" checked />
          <label></label>
        </div>
        <div class="toggle">
          <input type="checkbox" checked disabled />
          <label></label>
        </div>
      </div>
    </div>
    <h3>Radio</h3>
    <div class="ui-block">
      <div class="radio-group">
        <input type="radio" id="radio" name="radio" />
        <label for="radio">Radio</label>
      </div>
      <div class="radio-group">
        <input type="radio" id="radio2" name="radio" checked />
        <label for="radio2">Radio 2</label>
      </div>
      <div class="radio-group">
        <input type="radio" id="radio3" name="radio" disabled />
        <label for="radio3">Radio 3</label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const inputValue = ref("Value");
const selectValue = ref("France");
const selectMultipleValue = ref(["France", "UK"]);
const emptyValue = ref("");
</script>
